document.addEventListener('DOMContentLoaded', () => {
  const main = document.querySelector('#main');
  const searchToggle = document.querySelectorAll(
    '[aria-controls=site-search--desktop]'
  );
  const search = document.querySelector('.site-search');

  // Check if the menu is open
  function isSearchOpen() {
    return main.classList.contains('is-search-open') === true;
  }
  // Menu toggle buttons
  searchToggle.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      main.classList.toggle('is-search-open');
      search.setAttribute('aria-hidden', String(!isSearchOpen()));
      search.hidden = !isSearchOpen();
      if (isSearchOpen) {
        search.querySelector('input').focus();
      }
    });
  });

  // Init menu
  search.setAttribute('aria-hidden', String(!isSearchOpen()));
  search.hidden = !isSearchOpen();
});
